import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { sanityImageURL } from '../../helpers/sanity';
import useResponsiveLogo from '../../hooks/useResponsiveLogo';
import { useNavigate, useLocation } from 'react-router';

const DESKTOP_LOGO_STORAGE_KEY = 'logoSrc';
const MOBILE_LOGO_STORAGE_KEY = 'mobileLogoSrc';

type LogoProps = {
  size?: 'small' | 'medium';
  isClickable?: boolean;
};

const Logo = ({ size = 'medium', isClickable = true }: LogoProps) => {
  const { desktopImage, mobileImage, isMobile } = useResponsiveLogo();
  const desktopSanitySrc = sanityImageURL(desktopImage, { h: 60 });
  const mobileSanitySrc = sanityImageURL(mobileImage, { h: 60 });
  const sanitySrc = isMobile ? mobileSanitySrc || desktopSanitySrc : desktopSanitySrc;

  const storedDesktopSrc = localStorage.getItem(DESKTOP_LOGO_STORAGE_KEY) ?? '';
  const storedMobileSrc = localStorage.getItem(MOBILE_LOGO_STORAGE_KEY) ?? '';
  const storedSrc = isMobile ? storedMobileSrc || storedDesktopSrc : storedDesktopSrc;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const src = sanitySrc || storedSrc;
  const isHome = pathname === '/' || pathname.startsWith('/sports');

  const handleLogoClick = () => {
    if (!isClickable || isHome) return;
    navigate('/');
  };

  useEffect(() => {
    if (desktopSanitySrc) {
      localStorage.setItem(DESKTOP_LOGO_STORAGE_KEY, desktopSanitySrc);
    }
    if (mobileSanitySrc) {
      localStorage.setItem(MOBILE_LOGO_STORAGE_KEY, mobileSanitySrc);
    }
  }, [desktopSanitySrc, mobileSanitySrc]);

  return src ? (
    <Box
      component='img'
      src={src}
      alt='Logo'
      onClick={handleLogoClick}
      sx={{
        height: size === 'medium' ? '54px' : '32px',
        cursor: isClickable ? 'pointer' : 'auto',
      }}
    />
  ) : (
    <Typography variant={size === 'small' ? 'h3' : 'h1'} color='secondary'>
      LOGO
    </Typography>
  );
};

export default Logo;
